import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-plus-icon lucide-plus",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M5 12h14" }), /* @__PURE__ */ _jsx("path", { d: "M12 5v14" })]
});
export default SvgPlus;
